// extracted by mini-css-extract-plugin
module.exports = {"favour":"D4ngJEch","active":"_j0wdd90"};